module.exports = __webpack_public_path__ + "static/media/img101_R.eba7b2b3.jpg";